module.exports = __webpack_public_path__ + "img/featuredartist (8).b78483ac.jpg";